module.exports = ol.View;